/* ll-pdp-llamas.js: places the five llama moments (snippets/ll-pdp-llamas.liquid templates) into their anchors below the
   buy box, then plays one rise + one blink as each comes into view. Runs only with html.ll-chg-llamas (band section
   switch; ?ll_off=llamas removes it). No anchor = that moment is skipped. Reduced motion = static, no blink.
   Creative director, 2026-10-14. */
(function () {
  var H = document.documentElement;
  /* Llama rules (Brad 10-17, "llama should be removed here": Apron Earnest sat on the reviews seam, half cut by the band, over Ginger):
     1. a section that draws its own llama (all-reviews Ginger, the adult seam llama, or any [data-ll-own-llama]) gets no moment;
     2. a moment that lands within 60 px of another section's own llama is switched off (no two llamas stacked across a seam);
     3. a moment a landscape band or seam covers by more than 30% of its height is switched off (never clip a llama with a band).
     Switched-off moments stay in the DOM with .ll-llama--off (display:none in the CSS); nothing is deleted. */
  var OWN = '[data-ll-ar-llama], .ll-ar-llama, .ll-adult-seam-llama, [data-ll-own-llama]';
  var BANDS = '.ll-c-band, .ll-adult-seam, .ll-adult-ridge';
  function vet() {
    var own = [].slice.call(document.querySelectorAll(OWN)).filter(function (o) { return o.getBoundingClientRect().height > 0; });
    var bands = [].slice.call(document.querySelectorAll(BANDS)).filter(function (o) { return o.getBoundingClientRect().height > 0; });
    var els = document.querySelectorAll('.ll-llama:not(.ll-llama--off)');
    for (var i = 0; i < els.length; i++) {
      var el = els[i], art = el.querySelector('.ll-llama__art') || el, r = art.getBoundingClientRect();
      if (!r.height) continue;
      var off = false;
      for (var j = 0; j < own.length && !off; j++) {
        var o = own[j].getBoundingClientRect();
        if (own[j].closest('.shopify-section') === el.closest('.shopify-section') ||
            (Math.max(o.top - r.bottom, r.top - o.bottom) < 60 && o.left < r.right + 120 && o.right > r.left - 120)) off = true;
      }
      for (var k = 0; k < bands.length && !off; k++) {
        var q = bands[k].getBoundingClientRect(), ov = Math.min(q.bottom, r.bottom) - Math.max(q.top, r.top);
        if (q.left < r.right && q.right > r.left && ov > 0.3 * r.height) off = true;
      }
      if (off) el.classList.add('ll-llama--off');
    }
  }
  function place() {
    if (!H.classList.contains('ll-chg-llamas')) return;
    var tpls = document.querySelectorAll('template[data-ll-llama]');
    for (var i = 0; i < tpls.length; i++) {
      var t = tpls[i], min = +(t.getAttribute('data-min') || 0);
      if (min && window.innerWidth < min) continue;           /* desktop-only moments (CSS hides them under 1024 too) */
      var un = t.getAttribute('data-unless'); if (un && document.querySelector(un)) continue;   /* e.g. reviews2 only where there is no reviews module */
      var a = document.querySelector(t.getAttribute('data-anchor'));
      if (!a || a.getAttribute('data-ll-llama-done')) continue;
      var sec = a.closest('.shopify-section');
      if (sec && sec.querySelector(OWN)) continue;            /* rule 1: that section has its own llama */
      var frag = t.content.cloneNode(true), where = t.getAttribute('data-where');
      if (where === 'before') a.parentNode.insertBefore(frag, a);
      else if (where === 'prepend') a.insertBefore(frag, a.firstChild);
      else a.appendChild(frag);
      a.setAttribute('data-ll-llama-done', '1');
      a.classList.add('ll-llama-host', 'll-llama-host--' + t.getAttribute('data-ll-llama'));
      if (t.getAttribute('data-flag')) a.classList.add(t.getAttribute('data-flag'));
    }
    vet();
    window.addEventListener('load', vet);                     /* again once the seams (ll-pdp-adult.js) and fonts have laid out */
    var els = document.querySelectorAll('.ll-llama');
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (still || !('IntersectionObserver' in window)) { for (var j = 0; j < els.length; j++) els[j].classList.add('is-in'); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target; io.unobserve(el); el.classList.add('is-in');
        var art = el.querySelector('.ll-llama__art--blink');
        if (art) setTimeout(function () { art.classList.add('is-blink'); setTimeout(function () { art.classList.remove('is-blink'); }, 140); }, 900);
      });
    }, { rootMargin: '0px 0px -12% 0px' });
    for (var k = 0; k < els.length; k++) io.observe(els[k]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', place); else place();
})();
